var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCykel = function SvgCykel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeMiterlimit: 10,
    d: "m5.53 6.765-2.06 3.294m.412-4.118h2.492m1.214 3.294-2.47-3.294m7.412 4.118L9.977 4.228A1.26 1.26 0 0 0 8.82 3.47H7.177m1.235 5.765 2.059-4.118M5.94 10.06a2.47 2.47 0 1 1-4.94 0 2.47 2.47 0 0 1 4.94 0Zm9.06 0a2.47 2.47 0 1 1-4.942 0 2.47 2.47 0 0 1 4.941 0Zm-6.177 0a.824.824 0 1 1-1.647 0 .824.824 0 0 1 1.647 0Z"
  })));
};
export default SvgCykel;